import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["star"];
  static values = { rating: Number };

  connect() {
    this.updateDisplay();
  }

  rate(event) {
    const value = parseInt(event.currentTarget.dataset.value);
    this.ratingValue = value;
    this.updateDisplay();

    // Here you could make an AJAX request to save the rating
    // Example: this.saveRating(value);
  }

  updateDisplay() {
    this.starTargets.forEach((star, index) => {
      const value = index + 1;
      if (value <= this.ratingValue) {
        star.classList.remove("text-slate-500");
        star.classList.add("text-amber-400");
      } else {
        star.classList.remove("text-amber-400");
        star.classList.add("text-slate-500");
      }
    });
  }

  hover(event) {
    const value = parseInt(event.currentTarget.dataset.value);
    this.starTargets.forEach((star, index) => {
      const starValue = index + 1;
      if (starValue <= value) {
        star.classList.remove("text-slate-500");
        star.classList.add("text-amber-400");
      } else {
        star.classList.remove("text-amber-400");
        star.classList.add("text-slate-500");
      }
    });
  }

  unhover() {
    this.updateDisplay();
  }

  // saveRating(value) {
  //   // Implementation for saving rating to backend
  //   fetch(`/seasons/${this.data.get("seasonId")}/rating`, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
  //     },
  //     body: JSON.stringify({ rating: value })
  //   });
  // }
}
